<template>
  <div class="card assets-offline-map-list">
    <header class="card-header has-background-light">
      <p class="card-header-title has-text-dark">ASSETS LIST</p>
      <div class="buttons">
        <slot name="headerButtons" />
      </div>
    </header>
    <div class="card-content scrollable" :style="{ height: `${height}px` }">
      <slot name="contentTop" />
      <b-collapse class="card filters" :open="true">
        <div
          slot="trigger"
          slot-scope="props"
          class="card-header"
          role="button"
        >
          <p class="card-header-title">
            FILTER
          </p>
          <a class="card-header-icon">
            <b-icon :icon="props.open ? 'caret-down' : 'caret-up'"> </b-icon>
          </a>
        </div>
        <div class="card-content">
          <filters :contract="contract" :asset-types="assetTypes" @filter="onFilter" />
        </div>
      </b-collapse>
      <div style="padding: 10px">
        <asset-order-type-code-assign-tool
          :contract-id="contract"
          :filters="fetchParams"
          @assign="() => $emit('assign')"
          @unassign="() => $emit('unassign')"
        />
      </div>
      <base-table
        :service="$options.assetService"
        fetch-func="all"
        :fetch-params="fetchParams"
        :columns="$options.columns"
        default-sort-direction="desc"
        :per-page="$options.perPage"
        :selectable="true"
        :selected="selected"
        :sticky="true"
        :narrowed="false"
        @select="onSelect"
        ref="baseTable"
      >
        <template #rowCode="{ row }">
          {{ row.code ? row.code.name : "Unknown" }}
        </template>
        <template #rowStatus="{ row }">
          {{ row.status }}
        </template>
        <template #rowData="{ row }">
          <button class="button is-outline is-small" :title="JSON.stringify(row.tags)">DATA</button>
        </template>
      </base-table>
    </div>
  </div>
</template>

<script>
import Filters from "./AssetsOfflineMapListFilters";
import AssetOrderTypeCodeAssignTool from "@/components/Asset/AssetOrderTypeCodeAssignTool";
import BaseTable from "@/components/partials/BaseTable";
import { AssetService } from "@/services/asset.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

export default {
  assetService: AssetService,
  columns: [
    {
      field: "class",
      label: "CLASS",
      meta: {
        rowSlot: "rowCode"
      }
    },
    {
      field: "status",
      label: "STATUS",
      meta: {
        rowSlot: "rowStatus"
      }
    },
    {
      field: "data",
      label: "DATA",
      meta: {
        rowSlot: "rowData"
      }
    }
  ],
  perPage: 1000,
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    mapHeight: {
      type: Number,
      default: 500
    },
    selected: {
      type: Object
    },
    contract: {
      type: [String, Number]
    },
    orderTypeCode: {
      type: [String, Number]
    },
    assetTypes: {
      type: Array,
      default: () => []
    },
  },
  components: {
    Filters,
    AssetOrderTypeCodeAssignTool,
    BaseTable
  },
  data: () => ({
    assets: [],
    filters: {}
  }),
  computed: {
    fetchParams() {
      return {
        ...this.filters,
        contract_ids: [this.contract] || undefined,
        // orderType_code_id: this.orderTypeCode || undefined,
        orderType_code_ids: this.orderTypeCode ? [this.orderTypeCode] : undefined,
        include_archived: 1, // assuming this component is only being used in /assets-offline
      };
    },
    height() {
      // Card header height
      return this.mapHeight - 36;
    }
  },
  mounted() {
    // this.fetch();
  },
  methods: {
    fetch() {
      if (!this.contract) return;
      this.$refs.baseTable.fetchData();
    },
    onSelect(selected) {
      this.$emit("select", selected);
    },
    onFilter(filters) {
      this.filters = {
        centerX: this.config.center.lng,
        centerY: this.config.center.lat,
        ...filters
      };

      this.$nextTick(() => {
        this.fetch();
      });
    },
  }
};
</script>

<style lang="scss">
.assets-offline-map-list {
  .card-content {
    padding: 0;

    .b-table .table {
      border: none;
      th {
        position: sticky;
        top: 0;
        background: white;
        z-index: 1;
      }
    }

    .base-table--pagination {
      padding: 0 10px;
    }

    .filters {
      .card-content {
        padding: 1.5rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AssetsOfflineMapList.vue